module.exports = __webpack_public_path__ + "img/analytics_mobile_a45e6d3.webp";